import isEqual from "lodash/isEqual"

export function getUserData(state) {
  return state.session.user || {}
}

export function getBackUrl(state) {
  return state.session.backUrl
}

export function selectToken(state) {
  return state.session.token
}

export function selectTokenType(state) {
  return state.session.tokenType
}

export function refreshToken(state) {
  return state.session.refreshToken
}

export function pending(state) {
  return state.session.isLoading
}

export function request(state, action) {
  return state.session.requests.find(item => isEqual(item, action))
}

export function error(state) {
  return state.session.hasError
    ? state.session.errorText || new Error(`Неверный логин или пароль`)
    : false
}

export function requestsLocked(state) {
  return state.session.requestsLocked
}
